const resolveConfigObjects = require('./lib/util/resolveConfig').default;
const getAllConfigs = require('./lib/util/getAllConfigs').default;
module.exports = function resolveConfig() {
  for (var _len = arguments.length, configs = new Array(_len), _key = 0; _key < _len; _key++) {
    configs[_key] = arguments[_key];
  }
  const [, ...defaultConfigs] = getAllConfigs(configs[0]);
  return resolveConfigObjects([...configs, ...defaultConfigs]);
};